import React from 'react'
import styled from 'styled-components'
import InputMask from 'react-input-mask'

import LabelledField from 'components/LabelledField'

type PhoneInputProps = {
  label: string
  isRequired?: boolean
  errorMessage?: string
  className?: string
  [key: string]: unknown
}

const PhoneInput = ({ label, isRequired = false, errorMessage = '', className = '', ...inputProps }: PhoneInputProps) => {
  const id = label.replace(' ', '_')
  let inputMask = '(999) 999-9999'

  if (inputProps.value && (inputProps.value as string).length === 11) {
    inputMask = '9 (999) 999-9999'
  }
  return (
    <LabelledField {...{ id, label, isRequired, errorMessage, className }}>
      <S.InputMask mask={inputMask} type="tel" maskChar={null} {...{ id, ...inputProps }} />
    </LabelledField>
  )
}

export default PhoneInput

const S = {
  InputMask: styled(InputMask)`
    height: 39px;
    width: 100%;
    border-radius: 5px;
  `
}
